import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { signOut, onAuthStateChanged } from "firebase/auth";
import SetPassword from "./SetPassword";
import { getIdToken } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./Login";
import Dashboard from "./Dashboard";
import AdminPage from "./AdminPage";
import { API_BASE } from "./config";

function App() {
  const [authData, setAuthData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await getIdToken(user);
        const email = user.email;

        try {
          const res = await fetch(`${API_BASE}/get-user-metadata`, {
            headers: { Authorization: token },
          });
          if (!res.ok) throw new Error("Failed to load user metadata");
          const metadata = await res.json();

          setAuthData({
            token,
            email,
            role: metadata.role,
            company_id: metadata.company_id,
            client_name: metadata.client_name, 
            director: metadata.director, 
            state: metadata.state, 
            cx: metadata.cx, 
          });
        } catch (err) {
          console.error("Error loading metadata:", err);
          setAuthData(null);
        }
      } else {
        setAuthData(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    setAuthData(null);
  };

  if (loading) return <div className="text-center p-10 text-lg">Loading...</div>;

  return (
    <Routes>
      <Route path="/set-password" element={<SetPassword />} />

      {!authData ? (
        <Route path="*" element={<Login onLogin={(data) => setAuthData(data)} />} />
      ) : (
        <>
          <Route
            path="/"
            element={
              <Dashboard
                token={authData.token}
                userEmail={authData.email}
                role={authData.role}
                company_id={authData.company_id}
                onLogout={handleLogout}
                cx={authData.cx}
              />
            }
          />
          <Route
            path="/admin"
            element={
              <AdminPage
                token={authData.token}
                userEmail={authData.email}
                companyId={authData.company_id}
                role={authData.role}
                onLogout={handleLogout}
              />
            }
          />
        </>
      )}
    </Routes>
  );
}

export default App;
